import { useMemo } from 'react';
import { COUNTRY_CODES } from '../constants/countries';
import { localeI18nText } from '../utils/localeI18nText';
import useLocaleContext from '../hooks/useLocaleContext';
import { Select } from './Select';
import { jsx as _jsx } from "react/jsx-runtime";
export function CountryDropdown(props) {
  const {
    locale
  } = useLocaleContext();
  const options = useMemo(() => {
    return COUNTRY_CODES.map(countryCode => ({
      text: localeI18nText(`SharedI18nStrings.countryCodes.${countryCode}`, locale),
      value: countryCode
    }));
  }, [locale]);
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "country-select",
    onChange: evt => props.onChange(evt.target.value),
    options: options,
    placeholder: localeI18nText('app.country.placeholder', locale)
  });
}